import styled, { css } from 'styled-components';

import { ReactComponent as DraggableIcon } from '@pkg/components/Sections/Profile/icons/draggable.svg';

interface DraggableWrapperProps {
    $draggable: boolean;
    $dragging: boolean;
}

export const DraggableWrapper = styled.div<DraggableWrapperProps>`
    position: relative;
    width: 100%;
    height: 100%;

    ${({ $draggable }) =>
        $draggable &&
        css`
            &:hover ${StyledDraggableIcon} {
                opacity: 1;
            }
        `}

    ${({ $dragging }) =>
        $dragging &&
        css`
            ${StyledDraggableIcon}, ${ChildrenWrapper} {
                opacity: 0;
            }
        `}
`;

export const StyledDraggableIcon = styled(DraggableIcon)`
    position: absolute;
    top: 8px;
    left: 8px;
    z-index: 99;
    opacity: 0;
    transition: opacity ${({ theme }) => theme.transitions.speeds.normal}s;
    // Fallback if grab cursor is unsupported
    cursor: move;
    cursor: grab;
`;

export const ChildrenWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 100%;
    transform-origin: 0 0;
    transition:
        opacity ${({ theme }) => theme.transitions.speeds.fast}s,
        transform ${({ theme }) => theme.transitions.speeds.normal}s ${({ theme }) => theme.transitions.easesCss.cubic};
`;
